import getDashboardReducers from './dashboardReducers/combinedReducers';
import getStandaloneReducers from './standaloneReducers/combinedReducers';
import getHERReducers from './herReducers/combinedReducers';
import getWidgetReducers from './widgetReducers/combinedReducers';
import getPublicWidgetReducers from './publicWidgetReducers/combinedReducers';

export default function getAllReducers(appName){
  switch (appName) {
    case "Dashboard":
        return getDashboardReducers();
    case "Standalone" :
        return getStandaloneReducers();
    case "HER" :
        return getHERReducers();
    case "Widget" :
        return getWidgetReducers();
    case "PublicWidget" :
        return getPublicWidgetReducers();
    default:
      return;
  }
}
